import { isCustomDomain, shopPath } from './custom_domain';

export default {
  computed: {
    effectiveSlug() {
      return this.$route.params.slug
        || this.$store.state.public_shop.customDomainSlug
        || '';
    },
    onCustomDomain() {
      return isCustomDomain();
    },
  },
  methods: {
    shopPath(subPath = '') {
      return shopPath(this.effectiveSlug, subPath);
    },
  },
};
